module.exports = __webpack_public_path__ + "img/old-fashioned.387464ba.jpg";